var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found-page"},[_c('van-empty',{attrs:{"image":"error","description":"页面暂不可用"}},[_c('van-button',{attrs:{"size":"small","type":"primary","color":"#2e8b7a"},on:{"click":_vm.goHome}},[_vm._v("返回首页")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }